export const SUPPORTS = "SUPPORTS"

export const SUPPORT_FETCH_SUPPORT_LIST = "SUPPORT_FETCH_SUPPORT_LIST"
